import { useEffect, useMemo, useState } from 'react';
import { COMMON_MOBILE_BREAKPOINT } from '@elfsight/lib-utils';
import { useWidgetRect } from './widget-rect-context';

const BREAKPOINT_LAG = 30;

export const useIsMobileBreakpoint = (
  breakpoint = COMMON_MOBILE_BREAKPOINT
) => {
  const width = useWidgetRect()?.width;

  return useMemo(() => !width || width < breakpoint, [width, breakpoint]);
};

export function useStableIsMobileBreakpoint(
  breakpoint = COMMON_MOBILE_BREAKPOINT
) {
  const width = useWidgetRect()?.width;
  const [isMobile, setIsMobile] = useState(!width || width < breakpoint);

  useEffect(() => {
    if (!width) {
      return;
    }

    if (width < breakpoint) {
      setIsMobile(true);
    }

    if (width >= breakpoint + BREAKPOINT_LAG) {
      setIsMobile(false);
    }
  }, [width, breakpoint]);

  return isMobile;
}
